import styled from '@emotion/styled'
import { Button, Container, Grid } from '@mui/material'
import React from 'react'
import Menu from '../../../../Components/Menu'
import { SubHeading } from '../../../../Components/SubHeading'
import { Text } from '../../../../Components/Text'
import pulsePrinter from '../../../../images/pulse-printer.png'
import CMC from '../../../../images/cmc.png'
import CG from '../../../../images/cg.png'
import twitter from '../../../../images/twitter.png'
import telegram from '../../../../images/telegram.png'

const Heading = styled.h1`
  color: #ffffff;
  text-transform: uppercase;
  font-family: 'haettenschweiler';
  font-size: 14.2vw;
  letter-spacing: 5px;
  line-height: 90%;
  margin-bottom: 35px;
  
  @media (min-width: 900px) {
    font-size: 11.2vw;
    line-height: 85%;
  }
  @media (min-width: 1200px) {
    font-size: 12vw;
    line-height: 90%;
  }
  @media (min-width: 1536px) {
    font-size: 150px;
    line-height: 130px;
  }
`
const HeaderImage = styled.img`
  max-width: 380px;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  @media (max-width: 899px) {
    position: unset;
    margin: 35px auto;
  }
  @media (min-width: 900px) {
    max-width: 400px;
  }
  @media (min-width: 1200px) {
    max-width: 530px;
  }
  @media (min-width: 1536px) {
    max-width: 650px;
    width: 50%;
  }
`

const ButtonPrimary = styled(Button)`
  background: linear-gradient(225deg, #00D3FD, #7904FE, #F8063A);
  border-radius: 4px;
  font-family: "poppins"; 
  font-size: 15px;
  font-weight: 600;
  text-transform: unset;
  color: #ffffff;
  transition-duration: 0.5s;
  outline: unset !important;
  margin-bottom: 5px;
  
  @media (max-width: 599px) {
    margin-bottom: 25px;
  }

  &:hover, &:active, &:focus{
      color: #ffffff;
      background: linear-gradient(225deg, #00D3FD 5%, #7904FE 50%, #F8063A 95%);
      box-shadow: 0 0 15px #00D3FD30, 0 0 25px #00D3FD30, 0 0 35px #00D3FD30;
      transition-duration: 0.5s;
  }
`
const ButtonSecondary = styled(ButtonPrimary)`
  background: transparent;
  border: 2px solid #ffffff;
  height: 38px;
  
  &:hover, &:active, &:focus{
      color: #ffffff;
      background: transparent;
      box-shadow: 0 0 15px #00D3FD30, 0 0 25px #00D3FD30, 0 0 35px #00D3FD30;
      transition-duration: 0.5s;
  }
`
const Flex = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 10px;
  @media (max-width: 425px) {
    display: block;
  }
`
const ExternalLink = styled.a`
  color: #ffffff;
  text-decoration: unset;
  font-family: 'poppins';
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
`
const LogoExternal = styled.img`
  height: 50px;
  width: auto;
  margin-right: 20px;
`

export const Header = () => {
  return (
    <>
      <Menu />
      <Container maxWidth="xl" className='py-5'>
        <Grid container className="position-relative">
          <Grid
            xs={12}
            lg={8}
          >
            <Heading className='mt-xl-5'>
              hold and Print <br />Easy $PRINT
            </Heading>
            <Text mb='5px' maxWidth='570px'>
              Discover the power of holding with Pulse Printer ($PRINT), the community-driven token that rewards your loyalty through automatic-rewards along with anti-dump mechanisms. Whether you're an experienced trader or new to the crypto world, $PRINT is designed to help you succeed in the long run.
            </Text>
            <Text maxWidth='560px'>
              By holding $PRINT and reap your rewards in Pulse tokens!
            </Text>
            <ButtonPrimary href="https://app.pulsex.com/swap?outputCurrency=0x552ACf6CfB24aE2A3F9E19296ff3Cfe8ffa63532" target="blank" className='px-4 mr-3'>
              Buy Now
            </ButtonPrimary>
            <ButtonSecondary href="https://dexscreener.com/pulsechain/0xefeca2ea67badb4f9f3ca6d15eb7ed4d84c0f2be" target="blank" className='px-4'>
              Live Chart
            </ButtonSecondary>
            <Flex>
              <SubHeading mb="0">Find us on:</SubHeading>
              <ExternalLink><LogoExternal src={CMC} /></ExternalLink>
              <ExternalLink><LogoExternal src={CG} /></ExternalLink>
            </Flex>
            <Flex>
              <SubHeading mb="0">Follow us:</SubHeading>
              <ExternalLink href="https://twitter.com/pulseprinter" target="_blank"><LogoExternal src={twitter} /></ExternalLink>
              <ExternalLink href="https://t.me/pulseprintertoken" target="_blank"><LogoExternal src={telegram} /></ExternalLink>
            </Flex>
          </Grid>
          <HeaderImage src={pulsePrinter} />
        </Grid>
      </Container>
    </>
  )
}
